<template>

  <div class='myTile'>
    <p class='title is-3 is-6-mobile'>fast but not furious</p>
    <div class='has-text-left'>
      <p>Users who infected others did so quickly. The median time to infect another user was just <span class='myNumber'>{{ medianTimeToInfect }}</span>. About <span class='myNumber'>{{ pctUsersTransmitIn1Day }}</span> of infected users spread the virus within 24 hours of contracting it.</p>
      <br>
      <p>But despite spreading quickly, the virus did not spread far. The average infection rate was <span class='myNumber'>{{ avgInfectionRate }}</span>, just shy of the 1-to-1 ratio necessary to maintain a steady infected population. This suggests that even if the mods had not ended the event, the growth in cases had stalled.</p>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        medianTimeToInfect: '6 hours and 6 minutes',
        pctUsersTransmitIn1Day: '60%',
        avgInfectionRate: '.999',
      }
    }
  }
  
</script>
